import { SxProps } from '@mui/material'
import ModifierMediaTemplateServiceInterface
  from '~/src/components/products/modifier-groups/modifier-group/modifier/modifier-media/styles/ModifierMediaTemplateServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class ModifierMediaTemplateServiceStyleOne extends TemplateServiceStyleBase implements ModifierMediaTemplateServiceInterface {
  public getContainerSx(rounded: boolean): SxProps {
    return {
      height: '1.5em',
      width: '1.5em',
      borderRadius: rounded ? '50%' : 'var(--btn-border-radius)'
    }
  }
}
